import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

/**
 * When checkbox default behavior for `click` event is prevented, browser returns it's checked state back to
 * the original state, no matter if that state was altered during handling of the event or not.
 *
 * So this directive is here to correctly react on checked changes of checkboxes and fixes https://github.com/angular/angular/issues/9275
 */
@Directive({
    selector: 'input[type=checkbox][checked]',
})
export class CheckboxCheckedDirective {

    @Input() set checked(value: boolean) {
        setTimeout(() => {
            this.renderer.setProperty(this.elementRef.nativeElement, 'checked', value);
        });
    }

    constructor(private elementRef: ElementRef<HTMLInputElement>, private renderer: Renderer2) {}
}
